/**
 * NumberCell Component
 * 
 * Renders numeric values with:
 * - Proper formatting (thousands separator)
 * - Decimal precision handling
 * - Special display for null/undefined
 */

import { CellRendererProps } from '../../../../../types/AppPanel';

export default function NumberCell({ 
  value 
}: CellRendererProps<number | null | undefined>) {
  // Handle null/undefined
  if (value === null) {
    return <span className="text-white/30 italic">(null)</span>;
  }
  if (value === undefined) {
    return <span className="text-white/30 italic">(undefined)</span>;
  }

  // Handle NaN
  if (typeof value === 'number' && isNaN(value)) {
    return <span className="text-white/30 italic">NaN</span>;
  }

  // Format number with locale
  const formatted = typeof value === 'number' 
    ? value.toLocaleString('en-US', { 
        maximumFractionDigits: 6,
        useGrouping: true 
      })
    : String(value);

  return (
    <span className="font-mono text-white/80 tabular-nums">
      {formatted}
    </span>
  );
}

